import { style } from "@vanilla-extract/css";
import { theme } from "@huub-web/ui/theme/css/theme.css";
import { responsive } from "@huub-web/ui/utils/responsive";
import { recipe } from "@vanilla-extract/recipes";
import { transition } from "@huub-web/ui/utils/transition";

export const cardStyle = style({
  position: "relative",
  width: "100%",
  aspectRatio: "1/1.2",
  backgroundColor: theme.colors.backgroundShade,
  ...responsive({
    700: {
      aspectRatio: "4/3",
    },
    900: {
      aspectRatio: "16/9",
    },
  }),
});

export const timeControlsOverlayStyle = style({
  position: "absolute",
  left: 0,
  bottom: theme.spacings.m,
  width: "100%",
});

export const presetButtonsGrid = style({
  display: "grid",
  gridTemplateColumns: "repeat(auto-fit, minmax(100px, 1fr))",
  gap: theme.spacings.s,
  marginTop: theme.spacings.s,
});

export const sundialInfoContainer = style({
  marginTop: theme.spacings.l,
});

export const mapboxContainerStyle = style({
  position: "relative",
  width: "100%",
  height: "100%",
});

export const timeControlsContentStyle = style({
  flexDirection: "column-reverse",
  alignItems: "center",
  ...responsive({
    700: {
      flexDirection: "row",
    },
  }),
});

export const sundialMapStyle = recipe({
  base: {
    opacity: 0,
    transition: transition("opacity"),
  },
  variants: {
    loaded: {
      true: {
        opacity: 1,
      },
    },
  },
});
